import React, { memo } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconOrientation } from 'constants/coreDesignSystem';

import { defaultSize, orientationEnum, sizePropsTypes } from './icons.constants';

const LeftRightIcon = ({
  size = defaultSize,
  orientation = IconOrientation.ANGLE,
  className,
  ...props
}) => (
  <svg
    className={clsx(orientationEnum[orientation], className)}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.70711 7.70711C10.0976 7.31658 10.0976 6.68342 9.70711 6.29289C9.31658 5.90237 8.68342 5.90237 8.29289 6.29289L3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071L8.29289 17.7071C8.68342 18.0976 9.31658 18.0976 9.70711 17.7071C10.0976 17.3166 10.0976 16.6834 9.70711 16.2929L5.41421 12L9.70711 7.70711Z"
      fill="currentColor"
    />
    <path
      d="M14.2929 7.70711C13.9024 7.31658 13.9024 6.68342 14.2929 6.29289C14.6834 5.90237 15.3166 5.90237 15.7071 6.29289L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L15.7071 17.7071C15.3166 18.0976 14.6834 18.0976 14.2929 17.7071C13.9024 17.3166 13.9024 16.6834 14.2929 16.2929L18.5858 12L14.2929 7.70711Z"
      fill="currentColor"
    />
  </svg>
);

LeftRightIcon.propTypes = {
  ...sizePropsTypes,
  orientation: PropTypes.oneOf(Object.keys(orientationEnum)),
  className: PropTypes.string,
};

export default memo(LeftRightIcon);
